import { Collection } from 'modules/core/lib/mobx-rest'

import { TimeOption } from 'modules/automations/store/models/TimeOption'

export class TimeOptionsCollection extends Collection<TimeOption> {
  get cacheKey(): string {
    return 'timeOptions'
  }

  model() {
    return TimeOption
  }
}

export const timeOptions = new TimeOptionsCollection()
